import {useQuery, gql} from '@apollo/client'

export const GET_FILTER_DETAILS_LIST = gql`
  query GetFilterDetailsList {
    filterDetailsList {
      stateList {
        STATE_ID
        STATE_NAME
        STATE_ABBREVIATION
      }
      filterList {
        data {
          FILTER_CUSTOM_NAME
          FILTER_ID
          FILTER_NAME
          FILTER_KEY
          FILTER_CATEGORY_ID
        }
        filter_category_name {
          FILTER_CATEGORY_ID
          FILTER_CATEGORY_NAME
          FILTER_CATEGORY_CUSTOM_NAME
        }
      }
      pointOfInterestList {
        POI_ID
        POI_NAME
        POI_CUSTOM_NAME
      }
      usecaseList {
        title
        topics {
          custom_name
          name
        }
        subTopics {
          custom_name
          name
        }
        domains {
          custom_name
          name
        }
        useCases {
          custom_name
          name
          id
        }
      }
      personaList {
        data {
          custom_title
          title
          type
          data {
            name
            custom_name
          }
        }
      }
    }
  }
`

export const useGetFilterDetailsList = (statesConfig) => {
  const {
    loading: filterDetailsLoading,
    error: filterDetailsError,
    data,
    refetch: refetchFilterDetailsList
  } = useQuery(GET_FILTER_DETAILS_LIST)
  const sdohFilter = data?.filterDetailsList?.sdohList?.data?.map((filter) => {
    return {
      title: filter.FILTER_NAME,
      title_head: filter.FILTER_CATEGORY_NAME,
      FILTER_ID: filter.FILTER_ID,
      FILTER_CATEGORY_ID: filter.FILTER_CATEGORY_ID,
      IS_ACTIVE: filter.IS_ACTIVE,
      FILTER_KEY: filter.FILTER_KEY,
      FILTER_CUSTOM_NAME: filter.FILTER_CUSTOM_NAME
    }
  })
  const healthConditionFilter = data?.filterDetailsList?.healthEquityConditionList?.data.map(
    ({HEALTH_EQUITY_CONDITION_NAME: title, ...rest}) => ({
      title,
      ...rest
    })
  )

  const stateList = data?.filterDetailsList?.stateList
  let stateListFilter = []
  if (statesConfig.entireUnitedStateLabel) {
    if (stateList?.length === statesConfig.totalStates) {
      stateListFilter = [{STATE_ID: 0, STATE_NAME: statesConfig.entireUnitedStateLabel, IS_ACTIVE: true}, ...stateList]
    } else if (stateList) stateListFilter = stateList
    stateListFilter = stateListFilter.map(({STATE_NAME: title, ...rest}) => ({
      title,
      ...rest
    }))
  }
  const pointOfInterestFilter = data?.filterDetailsList?.pointOfInterestList?.map(({POI_NAME: title, ...rest}) => ({
    title,
    ...rest
  }))
  return {
    filterDetailsLoading,
    filterDetailsError,
    sdohFilter,
    data,
    healthConditionFilter,
    stateListFilter,
    pointOfInterestFilter,
    refetchFilterDetailsList
  }
}
